import React from 'react'
import './Footer.css'

const RegisterButton = () => {
  return (
    <div>
        <button className='register-btn text-black inline-block text-md px-3 py-2 leading-none rounded-full font-semibold'>Register Now</button>
    </div>
  )
}

export default RegisterButton